module.exports = __webpack_public_path__ + "static/tg-756d6b1bd6545f47f0f124cd17e2e0f1.png";